export const ACTIONS = ['KEEP', 'ADJUST', 'REPLACE', 'REMOVE'];
export function normalizedAction(item) {
  if (item?.confidence < 40 && ['REPLACE', 'REMOVE'].includes(item?.action)) return 'KEEP';
  return ACTIONS.includes(item?.action) ? item.action : 'KEEP';
}
export const MIN_LOCATION_CONFIDENCE = 60;
export const MIN_BBOX_EDGE = 0.02;
export const MIN_BBOX_AREA = 0.001;

export function bboxCenter(bbox) {
  if (!bbox) return null;
  const values = [bbox.x_min, bbox.y_min, bbox.x_max, bbox.y_max];
  if (!values.every(Number.isFinite)) return null;
  if (bbox.x_min < 0 || bbox.y_min < 0 || bbox.x_max > 1 || bbox.y_max > 1) return null;
  const width = bbox.x_max - bbox.x_min;
  const height = bbox.y_max - bbox.y_min;
  if (width <= 0 || height <= 0 || width < MIN_BBOX_EDGE || height < MIN_BBOX_EDGE || width * height < MIN_BBOX_AREA) return null;
  return { x: (bbox.x_min + bbox.x_max) / 2, y: (bbox.y_min + bbox.y_max) / 2 };
}

export function containRect(containerWidth, containerHeight, imageWidth, imageHeight) {
  if (![containerWidth, containerHeight, imageWidth, imageHeight].every((value) => Number.isFinite(value) && value > 0)) return null;
  const scale = Math.min(containerWidth / imageWidth, containerHeight / imageHeight);
  const width = imageWidth * scale;
  const height = imageHeight * scale;
  return { left: (containerWidth - width) / 2, top: (containerHeight - height) / 2, width, height };
}

export function bboxMarkerStyle(bbox) {
  const center = bboxCenter(bbox);
  return center ? { left: `${center.x * 100}%`, top: `${center.y * 100}%` } : null;
}

export function mapBboxCenterToContain(bbox, containerWidth, containerHeight, imageWidth, imageHeight) {
  const center = bboxCenter(bbox);
  const rect = containRect(containerWidth, containerHeight, imageWidth, imageHeight);
  if (!center || !rect) return null;
  return { x: rect.left + center.x * rect.width, y: rect.top + center.y * rect.height };
}

export function anchoredItems(items = []) {
  return items.map((item, index) => ({
    item, index, style: item?.location_confidence >= MIN_LOCATION_CONFIDENCE ? bboxMarkerStyle(item?.bbox) : null,
  })).filter(({ style }) => style);
}

export function scoreLabel(value) {
  return Number.isFinite(value) ? `${value}/100` : '—';
}

export function percentLabel(value) {
  return Number.isFinite(value) ? `${value}%` : '—';
}
